export default __webpack_public_path__ + "static/media/blurCourses1.70121d72.png";